module.exports = __webpack_public_path__ + "static/media/border-style.3818d4ba.svg";